/* eslint-disable */
import { Component, Mixins } from "vue-property-decorator";
import { Cell, CellGroup } from "vant";
import LegalAgreementsMixins from "@/mixins/legal-agreements";
import { RouterV2Enum } from "@/router/router-names";
import { AgreeInfos, LegalConstract } from "@/api/legal-constact/type";

const style = require("./index.module.scss");

@Component({ name: "CooperationChannel" })
export default class CooperationChannel extends Mixins(LegalAgreementsMixins) {
  private legalConstract: LegalConstract = Object.create(null);
  private async created() {
    this.legalConstract = await this.getLegalAgreements();
  }

  private onChannle(item: AgreeInfos) {
    this.$router.push({
      path: RouterV2Enum.channelConstract,
      query: {
        productName: item.productName,
        productId: String(item.productId),
      },
    });
  }

  private render() {
    return (
      <div class={style.CooperationChannel}>
        <CellGroup>
          {this.legalConstract &&
            this.legalConstract.agreementChannels &&
            this.legalConstract.agreementChannels.map((item) => (
              <Cell
                title={item.productName}
                isLink
                onClick={this.onChannle.bind(this, item)}
                key={item.productId}
              >
                <span slot="right-icon" class={style.rightIcon} />
              </Cell>
            ))}
        </CellGroup>
      </div>
    );
  }
}
